import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { Order } from '../models/Order'

type FetchOrderPayload = {
  orderId: EntityId
}

export const fetchOrder = createAsyncThunk('orders/fetchOrder', async ({ orderId }: FetchOrderPayload, _) => {
  const order = await OLMSApiService.get<Order>(`/order/${orderId}`)

  return order
})
